import { Modal, Form, notification, Select } from 'antd';
import React, { useState } from 'react';
import { _T } from '../../../../../base-react/src/Localization';
import { apis, hooks, models } from "@vote4dance/judging-sdk";
import { JudgingType, RoundType } from '@vote4dance/judging-schema';
var Api = apis.Api;
var RoundItem = models.rounds.RoundItem;
var Stream = hooks.streams.Stream;
var JudgingSource = models.judging.JudgingSource;
var ClassRoundSource = models.rounds.ClassRoundSource;
export const SeparatePosition = (props) => {
    const { federation_id, round, method, visible, setVisible, disabled, overrideUseAllJudges, overrideTitle } = props;
    const [judging, loadingJudging] = Stream(federation_id ? JudgingSource(federation_id) : undefined);
    const [isLoading, setIsLoading] = useState(false);
    const [isValidForm, setIsValidForm] = useState(false);
    const [form] = Form.useForm();
    const skatingData = RoundItem.getSkatingData(round);
    const onFinish = () => {
        setIsLoading(true);
        form
            .validateFields()
            .then(fieldsValue => {
            const positions = ['redance', 'override'].includes(method) ? fieldsValue['position'] : [fieldsValue['position']];
            if (positions.length > 0) {
                let placementJudging = judging === null || judging === void 0 ? void 0 : judging.find(a => a.judging_type === JudgingType.Placement);
                let overrideJudging = judging === null || judging === void 0 ? void 0 : judging.find(a => a.judging_type === JudgingType.Full);
                const useAllJudgesOverride = method == 'override' && overrideUseAllJudges;
                const overrideJudgingId = useAllJudgesOverride ? round.judging_id : overrideJudging === null || overrideJudging === void 0 ? void 0 : overrideJudging.judging_id;
                const roundTitle = method == 'override' && overrideTitle ? overrideTitle : _T('round.actions.' + method + '.title');
                const separateRound = {
                    round_parent_id: round.round_id,
                    round_type: method == 'sideSkating' ? RoundType.Skating : method == 'override' ? RoundType.Override : RoundType.Redance,
                    judging_id: method == 'sideSkating' ? round.judging_id : method == 'override' ? overrideJudgingId : placementJudging === null || placementJudging === void 0 ? void 0 : placementJudging.judging_id,
                    round_label: roundTitle,
                    round_num_through: method == 'sideSkating' ? round.round_num_through : 0,
                    round_count: 0,
                    round_num_heats: 1,
                    acro_id: round.acro_id,
                    schedule_id: round.schedule_id,
                    floor_id: round.floor_id,
                    round_heat_length: ['sideSkating', 'override'].includes(method) ? 0 : round.round_heat_length,
                    round_position: Math.min(...positions),
                    round_beat: round.round_beat,
                    round_hide_results_pos: round.round_hide_results_pos,
                    round_hide_results_type: round.round_hide_results_type
                };
                Api.create(`${ClassRoundSource(round.class_id).url}`, separateRound)
                    .then((result) => {
                    Api.call(`${ClassRoundSource(round.class_id).url}/${round.round_id}`, method == 'sideSkating' ? "skate-position" : method == 'override' ? 'override-position' : "redance-positions", {
                        target: result.round_id,
                        position: positions[0],
                        positions: positions
                    })
                        .then(() => {
                        form.resetFields();
                        setIsLoading(false);
                        setVisible(false);
                    })
                        .catch(err => {
                        setIsLoading(false);
                        notification.error({
                            message: _T(err.name)
                        });
                    });
                })
                    .catch((err) => {
                    setIsLoading(false);
                    notification.error({
                        message: err.message
                    });
                });
            }
            else {
                setIsLoading(false);
            }
        })
            .catch(info => {
            setIsLoading(false);
        });
    };
    const handleCancel = () => {
        form.resetFields();
        setVisible(false);
    };
    const onValuesChange = (changedValues, allValues) => {
        setIsValidForm(false);
        form
            .validateFields()
            .then(() => {
            setIsValidForm(true);
        })
            .catch(errorInfo => {
            setIsValidForm(errorInfo.errorFields.length == 0);
        });
    };
    const getAllPositionList = () => {
        return (skatingData
            .sort((a, b) => a.count - b.count)
            .filter((data) => !data.sideskated));
    };
    const getPositionList = () => {
        if (['redance', 'override'].includes(method)) {
            return (skatingData
                .sort((a, b) => a.count - b.count)
                .filter((data) => data.teams && data.teams.length > 1 && !data.sideskated));
        }
        else {
            return (skatingData
                .sort((a, b) => a.count - b.count)
                .reduce((buf, data) => {
                buf[buf.length - 1].unshift(data);
                if (!data.sideskated) {
                    buf.push([]);
                }
                return buf;
            }, [[]])
                .filter(data => data.length > 1)
                .map((data) => {
                return {
                    position: data[0].position,
                    count: data[0].teams.length,
                    possible: data.slice(1).map((d) => d.count).sort().join(", ")
                };
            }));
        }
    };
    var selectOptions = getPositionList().map((result) => ({
        label: _T('round.actions.' + method + '.position', result),
        value: result.position
    }));
    if (['redance', 'override'].includes(method)) {
        selectOptions = [
            {
                label: _T('round.actions.redance.shared-positions'),
                options: getPositionList().map((result, index) => ({
                    key: 'shared-' + index,
                    label: _T('round.actions.' + method + '.position', result),
                    value: result.position
                }))
            },
            {
                label: _T('round.actions.redance.all-positions'),
                options: getAllPositionList().map((result, index) => ({
                    key: 'all-' + index,
                    label: _T('round.actions.' + method + '.position', result),
                    value: result.position
                }))
            }
        ];
    }
    return (React.createElement(Modal, { title: method == 'override' && overrideTitle ? overrideTitle : _T('round.actions.' + method + '.title'), open: visible, okButtonProps: { form: 'separate_position', htmlType: 'submit', disabled: !isValidForm }, okText: _T('common.ok'), cancelText: _T('common.cancel.title'), confirmLoading: isLoading, onCancel: handleCancel, loading: loadingJudging },
        React.createElement(Form, { name: "separate_position", form: form, disabled: disabled, onFinish: onFinish, onValuesChange: onValuesChange },
            React.createElement(Form.Item, { name: "position", rules: [{ required: true }], extra: _T('round.actions.' + method + '.extra') },
                React.createElement(Select, { mode: ['redance', 'override'].includes(method) ? "multiple" : undefined, placeholder: _T('round.actions.placeholder'), options: selectOptions })))));
};
